import HeatingEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HeatingEnergy'
import HotwaterEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HotwaterEnergy'
import CookingEnergy from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/CookingEnergy'
import Surface from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/Surface'
import useAddress from '../../useAddress'

const Consumption = () => {
  const { t, isAllowedEnergyVertical } = useAddress()

  if (!isAllowedEnergyVertical) {
    return null
  }

  return (
    <>
      <h1>{t('subscriptionForm:address_v2.consumption_title')}</h1>
      <HeatingEnergy />
      <HotwaterEnergy />
      <CookingEnergy />
      <Surface />
    </>
  )
}

export default Consumption
